// src/context/AlertContext.js
import React, { createContext, useState, useContext, useCallback, useEffect } from "react";
import BmAlert from "../global-components/BM_Alert";
import { registerGlobalAlert } from "../bookingUtils/globalAlert";


const AlertContext = createContext();


export const AlertProvider = ({ children }) => {
  const [alert, setAlert] = useState(null);

  // Single global alert queue (you can later extend to multiple)
//   const showAlert = useCallback((type, mode, message, duration = 4000) => {
//     setAlert({ type, mode, message });

//     // Auto-dismiss after duration
//     if (duration !== 0) {
//       setTimeout(() => setAlert(null), duration);
//     }
//   }, []);


// showAlert with a debounce
const showAlert = useCallback((type, mode, message, duration = 4000) => {
  setAlert((prev) => {
    if (prev?.message === message && prev?.type === type) return prev;
    return { type, mode, message };
  });
  if (duration !== 0) {
    setTimeout(() => setAlert(null), duration);
  }
}, []);


  useEffect(() => {
    registerGlobalAlert(showAlert);
  }, [showAlert]);

  const clearAlert = useCallback(() => setAlert(null), []);

  return (
    <AlertContext.Provider value={{ showAlert, clearAlert }}>
      {children}
      {alert && (
        <BmAlert
          severity={alert.type}
          title={alert.type.toUpperCase()}
          message={alert.message}
          sx={{
            position: "fixed",
            bottom: 24,
            right: 24,
            zIndex: 9999,
            width: 400,
          }}
        />
      )}
    </AlertContext.Provider>
  );
};

// Hook for easy access
export const useAlert = () => useContext(AlertContext);
